import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Stethoscope, HeartPulse, Home, FlaskConical, AlertTriangle, Pill, MessageCircle, ArrowRight } from 'lucide-react';
export function NeedsTodayScreen() {
  const navigate = useNavigate();
  const needs = [{
    id: 'doctor',
    title: 'See a Doctor',
    icon: Stethoscope,
    color: 'bg-blue-100 text-blue-600'
  }, {
    id: 'nurse',
    title: 'Find a Nurse',
    icon: HeartPulse,
    color: 'bg-pink-100 text-pink-600'
  }, {
    id: 'home',
    title: 'Home Care',
    icon: Home,
    color: 'bg-purple-100 text-purple-600'
  }, {
    id: 'lab',
    title: 'Lab Test',
    icon: FlaskConical,
    color: 'bg-teal-100 text-teal-600'
  }, {
    id: 'meds',
    title: 'Medication',
    icon: Pill,
    color: 'bg-orange-100 text-orange-600'
  }, {
    id: 'chat',
    title: 'Chat Consult',
    icon: MessageCircle,
    color: 'bg-indigo-100 text-indigo-600'
  }];
  return <div className="min-h-screen bg-ui-bg flex flex-col" data-id="element-1033">
      <div className="pt-12 px-6 pb-6 flex justify-between items-start" data-id="element-1034">
        <div data-id="element-1035">
          <h1 className="text-3xl font-bold text-text-main mb-2" data-id="element-1036">
            What do you need today?
          </h1>
          <p className="text-text-secondary" data-id="element-1037">
            Select a service to get started quickly.
          </p>
        </div>
        <button onClick={() => navigate('/home')} className="text-brand-primary font-medium text-sm bg-brand-light px-3 py-1.5 rounded-full" data-id="element-1038">
          Skip
        </button>
      </div>

      <div className="px-6 flex-1 pb-8" data-id="element-1039">
        <div className="grid grid-cols-2 gap-4 mb-6" data-id="element-1040">
          {needs.map((need, idx) => <motion.button key={need.id} initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: idx * 0.05
        }} onClick={() => navigate('/home')} className="flex flex-col items-center justify-center p-6 bg-white border border-ui-border rounded-2xl shadow-sm active:bg-ui-card active:scale-[0.98] transition-all" data-id="element-1041">
              <div className={`w-14 h-14 rounded-full flex items-center justify-center mb-3 ${need.color}`} data-id="element-1042">
                <need.icon size={28} data-id="element-1043" />
              </div>
              <span className="font-semibold text-text-main text-sm" data-id="element-1044">
                {need.title}
              </span>
            </motion.button>)}
        </div>

        <motion.button initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} onClick={() => navigate('/emergency')} className="w-full flex items-center justify-between p-5 bg-status-emergency/10 border border-status-emergency/20 rounded-2xl active:scale-[0.98] transition-transform" data-id="element-1045">
          <div className="flex items-center" data-id="element-1046">
            <div className="w-12 h-12 bg-status-emergency text-white rounded-full flex items-center justify-center mr-4" data-id="element-1047">
              <AlertTriangle size={24} data-id="element-1048" />
            </div>
            <div className="text-left" data-id="element-1049">
              <h3 className="font-bold text-status-emergency text-lg" data-id="element-1050">
                Emergency Help
              </h3>
              <p className="text-sm text-status-emergency/80" data-id="element-1051">
                Get immediate assistance
              </p>
            </div>
          </div>
          <ArrowRight className="text-status-emergency" size={20} data-id="element-1052" />
        </motion.button>
      </div>
    </div>;
}